import { WalletCard } from '@givebacks/api/backer';
import { useFeatureFlag_Core } from 'core';
import { useNavigate } from 'react-router-dom';
import { EventWalletCard } from 'ui';

interface ConsumerWalletEventProps {
  walletCard: WalletCard;
}
const ConsumerWalletEvent = ({ walletCard }: ConsumerWalletEventProps) => {
  const navigate = useNavigate();

  const { isFeatureEnabled: isAccountPageEnabled } = useFeatureFlag_Core({
    featureId: 'user.account_page',
  });

  if (!walletCard.event) return null;

  return (
    <EventWalletCard
      ticketCount={walletCard.event.ticket_count}
      imageSrc={walletCard.event.image_url}
      eventName={walletCard.event.name ?? ''}
      startingAt={walletCard.event.first_ticket_at}
      endingAt={walletCard.event.last_ticket_at}
      onClick={() =>
        navigate(
          `${isAccountPageEnabled ? '' : 'events/'}${walletCard?.event?.uuid}?cause_id=${walletCard?.event?.cause_id}`
        )
      }
    />
  );
};

export { ConsumerWalletEvent };
